import produce from 'immer';

import {
  CONFIG_PAYMENT_GATEWAY_INTEGRATION_FETCH_FAILURE,
  CONFIG_PAYMENT_GATEWAY_INTEGRATION_FETCH_SUCCESS,
} from '@actions/configPayment';

const initialState: IConfigPaymentIntegrationStore = {
  isFetching: false,
  error: null,
  configPaymentGatewayIntegration: null,
};

export default (state: IConfigPaymentIntegrationStore = initialState, action: any) =>
  produce(state, (draftState: IConfigPaymentIntegrationStore) => {
    switch (action.type) {
      case CONFIG_PAYMENT_GATEWAY_INTEGRATION_FETCH_SUCCESS:
        draftState.isFetching = true;
        draftState.configPaymentGatewayIntegration = action.response;
        draftState.error = null;

        return;

      case CONFIG_PAYMENT_GATEWAY_INTEGRATION_FETCH_FAILURE:
        draftState.isFetching = false;
        draftState.error = action.error;

        return;
    }
  });
